module.exports = __webpack_public_path__ + "img/addon-drive.342a4536.png";